const ProgramRow = ({ item }) => (
  <>
    <td className="px-6 py-4">
      <div className="text-sm font-medium text-gray-900">{item.title}</div>
      <div className="text-sm text-gray-500">{item.subtitle}</div>
    </td>
    <td className="px-6 py-4 whitespace-nowrap">
      <div className="flex flex-wrap gap-1">
        {item.category.map((cat, index) => (
          <span key={index} className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-indigo-100 text-indigo-800">
            {cat}
          </span>
        ))}
      </div>
    </td>
    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.duration}</td>
    <td className="px-6 py-4 whitespace-nowrap">
      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
        item.status === 'Open' ? 'bg-green-100 text-green-800' : 
        item.status === 'Closed' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'
      }`}>
        {item.status}
      </span>
    </td>
    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.nextCohort}</td>
    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {item.featured ? (
        <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-purple-100 text-purple-800">
          Featured
        </span>
      ) : (
        <span className="text-gray-400">-</span>
      )}
    </td>
  </>
);

export default ProgramRow;
